import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AreYouAProSection = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-gradient-to-br from-[#e8f0fe] via-white to-[#f0f7ff] py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left column */}
          <div className="md:col-span-3">
            <h2 className="text-3xl md:text-4xl font-bold text-[#013776] mb-4">Sei un professionista serio? 

            </h2>
            <p className="text-gray-600 mb-6 text-lg">Solo richieste vicino a te, paghi solo quando un cliente accetta, niente pacchetti pre-pagati.

            </p>

            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-[#2780b5] flex-shrink-0 mt-0.5" />
                <p className="text-gray-700">Matching geografico: solo lavori in zona, nessuna perdita di tempo</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-[#2780b5] flex-shrink-0 mt-0.5" />
                <p className="text-gray-700">Paghi 0,99 solo quando il tuo preventivo viene confermato</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-[#2780b5] flex-shrink-0 mt-0.5" />
                <p className="text-gray-700">Le prime 10 risposte gratuite così avrai modo di testare la piattaforma</p>
              </div>
            </div>

            <button
              onClick={() => navigate('/signup-form?role=professional')}
              className="mt-8 hover:bg-[#104d98] text-white font-semibold px-6 py-3 rounded-full transition-colors bg-[rgba(16,82,152,1)]">Inizia oggi


            </button>
          </div>

          {/* Right column */}
          <div className="md:col-span-2">
            <img
              src="/assets/images/pro_at_phone.png"
              alt="Artigiano italiano che controlla lo smartphone sorridendo, luce calda, colori blu"
              className="rounded-3xl shadow-2xl w-full" />

          </div>
        </div>
      </div>
    </section>);

};

export default AreYouAProSection;